<div class="topbar" [ngClass]="{ 'hide-desktop': !swapRequest() }">
  <div class="user-info">
    <button class="chatlist-toggle" (click)="toggleChatList()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-menu">
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="18" x2="21" y2="18" />
      </svg>
    </button>
    @if (swapRequest()) {
      <div class="avatar">
        {{ swapRequest()?.user?.name?.charAt(0) }}
      </div>
      <div class="text">
        <div class="name">{{ swapRequest()?.user?.name }} {{ swapRequest()?.user?.surname }}</div>
      </div>
    }
  </div>
  <div class="actions">
    <div class="dropdown-container">
      <button class="icon-button" (click)="toggleDropdown()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-ellipsis-vertical h-4 w-4">
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="12" cy="5" r="1"></circle>
          <circle cx="12" cy="19" r="1"></circle>
        </svg>
      </button>

      <div class="dropdown-menu" *ngIf="isDropdownOpen">
        <button class="dropdown-item" (click)="openPropertyView()">View Property</button>
      </div>
    </div>
  </div>
</div>

@if (swapRequest()) {
  <div class="messages" #messagesContainer>
    <!-- Loading indicator -->
    <div *ngIf="loading()" class="loading-indicator">
      <div class="loading-spinner"></div>
      Loading...
    </div>
    @for (message of messages(); track message.id) {
      <div class="message" [class.me]="message.senderSwapRequest !== swapRequest()?.id">
        <div class="bubble">
          {{ message.content }}
          <span class="time">{{ message.createdAt | date }}</span>
        </div>
      </div>
    }
  </div>

  <div class="composer">
    <input
      [(ngModel)]="messageText"
      (input)="checkInput()"
      (keydown.enter)="sendMessage()"
      class="message-input"
      placeholder="Type your message..." />
    <button [disabled]="isSendButtonDisabled" class="send-button" [ngClass]="{ disabled: isSendButtonDisabled }" (click)="sendMessage()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-send h-4 w-4">
        <path
          d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path>
        <path d="m21.854 2.147-10.94 10.939"></path>
      </svg>
    </button>
  </div>
} @else {
  <div class="select-conversation-container">
    <div>
      <img alt="empty-conversation" src="/images/empty-conversation.svg" />
    </div>
    <h1>{{ "select_conversation_to_start" | translate }}</h1>
    <sxw-button
      severity="secondary"
      iconWidth="20px"
      iconHeight="20px"
      [outlined]="true"
      label="search_for_swap_request"
      icon="search"
      routerLink="/"></sxw-button>
  </div>
}

<!--TODO: handle in a better way !!!!-->
<div class="chatlist-modal" *ngIf="showChatList">
  <div class="modal-overlay" (click)="toggleChatList()"></div>
  <div class="modal-content">
    <app-conversations-list [activeConversationId]="swapRequest()?.id"></app-conversations-list>
  </div>
</div>
